import { scenes } from "../scenes";
import { Scene, Choice, Dialog } from "../models";

const fightDialogs = [
  new Dialog(
    "SONNY YANG: Sorry Dareth, but I like many others adhere to the age - old adage of “first come, first served” heheh.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-14-Sonny1-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: You leave me no choice Sonny Yang…",
    require("@/images/Dareth_Schamren.png"),
    require("@/audio/Pandemic-14-Dareth-MP3.mp3")
  ),
];

const tradeDialogs = [
  new Dialog(
    "SONNY YANG: How about a trade Dareth old boy? You let me have these supplies, and in return… I give you some of this.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic_15-Sonny.mp3")
  ),
  new Dialog(
    "",
    require("@/images/Finger.png"),
    require("@/audio/flipoff.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: You leave me no choice Sonny Yang…",
    require("@/images/Dareth_Schamren.png"),
    require("@/audio/Pandemic-14-Dareth-MP3.mp3")
  ),
];

const giveDialogs = [
  new Dialog(
    "SONNY YANG: I don’t want any trouble Dareth, just take the items and leave me be.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-16-Sonny-MP3.mp3")
  ),
  new Dialog(
    "DARETH SCHAMREN: Much obliged Sonny Yang. I’m going to punch you in the head anyway because I don’t like you.",
    require("@/images/Dareth_Schamren.png"),
    require("@/audio/Pandemic-16-Dareth-MP3.mp3")
  ),
];

export class FightScene extends Scene {
  image = require("@/images/Dareth_Schamren.png");
  title = "Inside Supermarket";

  get options(): any[] {
    return [
      new Choice("Fight!", async () => {
        await this.dialogRunner(fightDialogs)
        await this.next();
      }),
      new Choice("Strike a deal with Darren", async () => {
        await this.dialogRunner(tradeDialogs)
        await this.next();
      }),
      new Choice("Give Darren the items", async () => {
        await this.dialogRunner(giveDialogs)
        await this.next()
      })
    ];
  }

  async next() {
    this.state.inventory.beans.has = false;
    this.state.inventory.handSanitizer.has = false;
    this.state.inventory.toiletPaper.has = false;
    this.state.storylines.seekRevenge = true;
    await this.navigate(scenes.Knockout());
  }
}

export default new FightScene();
